import { Link } from "react-router-dom";

const Logo = ({ variant = "nav" }) => {
    if (variant === "full") {
        return (
            <Link to="/" data-testid="logo-link" className="inline-block shrink-0">
                <img src="/logo.png" alt="Solid Ground Solutions" className="w-48 md:w-56 h-auto" />
            </Link>
        );
    }

    return (
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 shrink-0 group">
            <img src="/logo-icon.png" alt="Solid Ground Solutions" className="h-10 w-10 md:h-11 md:w-11 object-cover" />
            <span className="font-heading leading-none tracking-tight text-white">
                <span className="block text-sm md:text-base font-extrabold uppercase">Solid Ground</span>
                <span className="block text-[10px] md:text-xs font-medium uppercase tracking-[0.35em] text-[#FF5C00]">Solutions</span>
            </span>
        </Link>
    );
};

export default Logo;
